export enum ChartTypes {
  BAR = 'bar',
  LINE = 'line',
}

export interface Color {
  r: number;
  g: number;
  b: number;
}

export interface ChartDataSet {
  chartType: ChartTypes;
  label: string;
  x: any;
  y: any;
  colors: Color[];
  style: ChartDataSetStyle;
  assetId?: number;
  dataSetId?: string;
  showSum?: boolean;
  sum?: number;
}

export interface ChartDataSetStyle {
  label?: string;
  borderColor?: string;
  hoverBorderColor?: string;
  borderWidth?: number;
  fill?: boolean;
  showLine?: boolean;
  pointStyle?: any;
  pointRadius?: any;
  borderDash?: any;
}
